<template> 
    <div v-show="loaded" class="iframe-container" :style="[hasEstiloContainer ? setEstiloContainer : '']">
        <div id="embeddingContainer" :style="[hasEstiloIframe ? setEstiloIframe : '']"></div>
    </div>
</template>

<script>

import { embedDashboard } from 'amazon-quicksight-embedding-sdk'
import MetodosGlobais from '@/utils/MetodosGlobais'

export default {
  name: 'iframeQuickSight',
  components: {
  },
  props:{
    fonte: {
      type: Object,
      default: () => ({})
    },

    allowfullscreen: null
  },
  data() {
    return {
      loaded: false,
      hasEstiloContainer: false,
      hasEstiloIframe: false,
      estiloContainer: '',
      estiloIframe: '',
    }
  },
  watch: {
    fonte: function (newFonte, oldFonte) {
        if(typeof newFonte === 'object' && typeof newFonte.iframeEmbeddingConfig === 'object' &&
            !MetodosGlobais.isTextoVazio(newFonte.iframeEmbeddingConfig.embedUrl)){
            this.fonte = newFonte
            if(MetodosGlobais.isObject(newFonte.iframeEmbeddingConfig.estiloContainer) && 
              Object.keys(newFonte.iframeEmbeddingConfig.estiloContainer).length) {
                this.estiloContainer = newFonte.iframeEmbeddingConfig.estiloContainer
                this.hasEstiloContainer = true
            } else {
              if(newFonte.iframeEmbeddingConfig.height) {
                  this.estiloContainer = {"height": newFonte.iframeEmbeddingConfig.height}
                  this.hasEstiloContainer = true
              }
            }
            if(MetodosGlobais.isObject(newFonte.iframeEmbeddingConfig.estiloIframe) && 
              Object.keys(newFonte.iframeEmbeddingConfig.estiloIframe).length) {
                this.estiloIframe = newFonte.iframeEmbeddingConfig.estiloIframe
                this.hasEstiloIframe = true
            }
            this.embedDashboardQuickSight()
        }
    }
  },
  created () {
    this.$store.commit('loading/startLoading');
  },
  computed: {
    setEstiloContainer() {
      return this.estiloContainer
    },
    setEstiloIframe() {
      return this.estiloIframe
    }
  },
  methods: {
		load: function(){
      if(this.fonte.iframeEmbeddingConfig.embedUrl) {
        this.loaded = true;
        this.$store.commit('loading/endLoading');
      }
    },
    embedDashboardQuickSight() {
      let containerDiv = document.getElementById("embeddingContainer");
      let options = {
          url: this.fonte.iframeEmbeddingConfig.embedUrl,
          container: containerDiv,
          parameters: {
              country: "Brazil"
          },
          scrolling: this.fonte.iframeEmbeddingConfig.scrolling,
          height: "100%",
          iframeResizeOnSheetChange: this.fonte.iframeEmbeddingConfig.iframeResizeOnSheetChange,
          width: this.fonte.iframeEmbeddingConfig.width,
          locale: "pt-BR",
          footerPaddingEnabled: this.fonte.iframeEmbeddingConfig.footerPaddingEnabled,
          printEnabled: this.fonte.iframeEmbeddingConfig.printEnabled,
      };
      let dashboard = embedDashboard(options);
      dashboard.on("error", this.onError);
      dashboard.on("load", this.load);
    },
    onError: function(payload) {
      console.error(payload)
    }
  }
  
}
</script>

<style scoped>

.iframe-container {
  overflow: hidden;
  position: relative;
}
@media (min-width: 858px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 767px) and (max-width: 857px) {
  .iframe-container {
    height: calc(100vh - 190px);
  }
}

@media (min-width: 614px) and (max-width: 766px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 364px) and (max-width: 613px) {
  .iframe-container {
    height: calc(100vh - 200px);
  }
}
@media (max-width: 363px) {
  .iframe-container {
    height: calc(100vh - 262px);
  }
}

.iframe-container #embeddingContainer {
   border: 0;
   height: 100%;
   left: 0;
   position: relative;
   top: 0;
   width: 100%;
}
 

</style>



